export { fromLegacyPlacement, placementMapping } from '../placement-map';
export type { TLegacyPlacement, TPlacementOptions } from '../placement-map';
